export default "/_next/static/assets/fonts/GoodOTCond-Ultra.cf29389e05f7e836082017607566b3ef.woff2";